import { SafeSet } from "openchat-shared";
import {} from "./undo";
export class LocalSet {
    serialiser;
    deserialiser;
    #queue = [];
    constructor(serialiser, deserialiser) {
        this.serialiser = serialiser;
        this.deserialiser = deserialiser;
    }
    get added() {
        return new Set(this.#queue.filter((m) => m.kind === "add").map((m) => m.value));
    }
    get removed() {
        return new Set(this.#queue.filter((m) => m.kind === "remove").map((m) => m.value));
    }
    // only use for testing
    clear() {
        this.#queue = [];
    }
    add(thing) {
        const add = { kind: "add", value: thing };
        this.#queue.push(add);
        return () => {
            this.#queue = this.#queue.filter((m) => m !== add);
        };
    }
    remove(thing) {
        const remove = { kind: "remove", value: thing };
        this.#queue.push(remove);
        return () => {
            this.#queue = this.#queue.filter((m) => m !== remove);
        };
    }
    apply(original) {
        if (this.#queue.length === 0)
            return original;
        const merged = new SafeSet(this.serialiser, this.deserialiser);
        for (const v of original) {
            merged.add(v);
        }
        for (const mod of this.#queue) {
            if (mod.kind === "remove") {
                merged.delete(mod.value);
            }
            if (mod.kind === "add") {
                merged.add(mod.value);
            }
        }
        return merged;
    }
}
export class ChatLocalSet extends LocalSet {
    constructor() {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)));
    }
}
